require('./tooltip.styl');

import React from 'react';

class Tooltip extends React.Component {

  constructor(props) {
    super(props);

    this.state= {
      width: this.props.chartWidth,
      showTooltip: false
    }

  }

  render() {

    let transform = '';
    let transformText = 'translate('+this.props.tooltipWidth/2+','+(this.props.tooltipHeight/2-8)+')';
    let transformArrow = '';

    let x = this.props.tooltipPosX;
    let y = this.props.tooltipPosY;

    // Large Tooltips

      // TOOLTIP TOP OF CIRCLE
      if(y > this.props.tooltipHeight){
        // console.log(y);
        transform='translate(' + (x-this.props.tooltipWidth/2) + ',' + (y-this.props.tooltipHeight-15) + ')';
        transformArrow='translate('+(this.props.tooltipWidth/2-20)+','+(this.props.tooltipHeight-3)+')';
        // LEFT BOUNDARY
        if(x < (this.props.tooltipWidth)) {
          transform='translate(' + (x-20) + ',' + (y-this.props.tooltipHeight-20) + ')';
          transformArrow='translate('+(0)+','+(this.props.tooltipHeight-3)+')';
        }
        if(x > (this.props.chartWidth - this.props.tooltipWidth)) {
          transform='translate(' + (x-this.props.tooltipWidth+20) + ',' + (y-this.props.tooltipHeight-15) + ')';
          transformArrow='translate('+(this.props.tooltipWidth-40)+','+(this.props.tooltipHeight-3)+')';
        }
        // RIGHT BOUNDARY

      // TOOLTIP BOTTOM OF CIRCLE
      }else if(y < this.props.tooltipHeight) {
        transform = 'translate(' + (x - this.props.tooltipWidth / 2) + ',' + (Math.round(y) + 15) + ')';
        transformArrow = 'translate(' + (this.props.tooltipWidth / 2 - 20) + ',' + 2 + ') rotate(180,20,0)';
        // LEFT BOUNDARY
        if (x < this.props.tooltipWidth) {
          transform = 'translate(' + (x - 20) + ',' + (Math.round(y) + 20) + ')';
          transformArrow = 'translate(' + (0) + ',' + 2 + ') rotate(180,20,0)';
        }
        // RIGHT BOUNDARY
        if (x > (this.props.chartWidth - this.props.tooltipWidth)) {
          transform = 'translate(' + (x - this.props.tooltipWidth + 20) + ',' + (Math.round(y) + 15) + ')';
          transformArrow = 'translate(' + (this.props.tooltipWidth - 40) + ',' + 2 + ') rotate(180,20,0)';
        }



      }

    return(
      <g transform={transform} className={`tooltip-wrapper ${this.props.tooltipClassName}`}>
        <rect className='shadow' width={this.props.tooltipWidth} height={this.props.tooltipHeight} rx='1' ry='1' fill={this.props.tooltipBackground} opacity='1'/>
        <polygon className='shadow' points='10,0  30,0  20,10' transform={transformArrow}
                 fill={this.props.tooltipBackground} opacity='1' />
        <text transform={transformText}>
          <tspan x='0' textAnchor='middle' dy={this.props.tooltipYOffset ? this.props.tooltipYOffset : '-3.5'} fontSize={`${this.props.tooltipFontSize}px`} fill={this.props.tooltipColor}>{this.props.tooltipPrefix}{this.props.tooltipTitle}{this.props.tooltipSuffix}</tspan>

          <tspan x='0' textAnchor='middle' dy={this.props.tooltipFontSize+3} fontSize={`${this.props.tooltipFontSize}px`} fontFamily='Benton Sans Cond' fontWeight='medium' fill={this.props.tooltipColor}>

            { this.props.tooltipCountPrefix &&
            this.props.tooltipCountPrefix
            }

            {this.props.tooltipCountAbsolute}

          {this.props.tooltipCountSuffix}</tspan>

          <tspan x='0' textAnchor='middle' dy={this.props.tooltipFontSize*1.33} fontSize={`${this.props.tooltipFontSize}px`} fontFamily='Benton Sans Cond' fontWeight='medium' fill={this.props.tooltipColor}>
            {this.props.tooltipCountAbsolutePrefix} {this.props.tooltipCountPercentage}{this.props.tooltipCountAbsoluteSuffix}
          </tspan>

        </text>
      </g>
    )

  }
}

Tooltip.propTypes = {
  tooltipPosX: React.PropTypes.number,
  tooltipPosY: React.PropTypes.number,
  tooltipWidth: React.PropTypes.number,
  tooltipHeight: React.PropTypes.number,
  chartWidth: React.PropTypes.number,
  chartHeight: React.PropTypes.number,
  tooltipClassName: React.PropTypes.string,
  tooltipBackground: React.PropTypes.string,
  tooltipCount: React.PropTypes.string,
  tooltipAbsoluteCount: React.PropTypes.string,
  tooltipTitle: React.PropTypes.string,
  tooltipColor: React.PropTypes.string,
  tooltipData: React.PropTypes.array,
  tooltipSize: React.PropTypes.string,
  tooltipFontSize: React.PropTypes.number,
  tooltipPrefix: React.PropTypes.string,
  tooltipSuffix: React.PropTypes.string,
  tooltipCountSuffix: React.PropTypes.string,
  tooltipCountPrefix: React.PropTypes.string,
  tooltipCountAbsolute: React.PropTypes.string,
  tooltipCountPercentage: React.PropTypes.string,
  tooltipCountAbsolutePrefix: React.PropTypes.string,
  tooltipCountAbsoluteSuffix: React.PropTypes.string,
  tooltipYOffset: React.PropTypes.number
}

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/tooltip/Tooltip.js